var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ranges"},_vm._l((_vm.options),function(option,index){return _c('div',{key:index,staticClass:"has-cursor-pointer range",class:_vm.active &&
      option.dateFrom === _vm.active.dateFrom &&
      option.dateTo === _vm.active.dateTo
        ? 'is-active'
        : null,on:{"click":function($event){return _vm.onFocusedDateChanged(option)}}},[_vm._v("\n    "+_vm._s(option.label)+"\n  ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }